// Configuration file for feature flags and environment variables
// In a real production app, these would come from environment variables
// For now, we'll set them as constants that can be easily changed

export const config = {
  // Feature Flags
  SHOP_ENABLED: false,
  ANNUAL_REPORTS_ENABLED: process.env.REACT_APP_ANNUAL_REPORTS === 'true',
  NEW_REPORTS_ENABLED: true,

  // API Base URLs - from environment variable with fallback
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  GO_API_BASE_URL:
    process.env.REACT_APP_GO_API_BASE_URL || 'http://localhost:8081',

  /** Google reCAPTCHA v3 site key (public). When empty, donation flows skip client token (hub must skip verify). */
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',

  /**
   * Stripe publishable key for Elements (public). Required for donation checkout; set at build time.
   * @type {string}
   */
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',

  // Mapbox Configuration
  MAPBOX_ACCESS_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,

  // Debug Mode
  DEBUG_MODE: process.env.NODE_ENV === 'development',

  // Events Tab Enabled
  EVENTS_TAB_ENABLED: true,
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureName) => {
  return config[featureName] === true;
};
